import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="timetable--form-modal"
export default class extends Controller {
  static targets = ['bandModal', 'timetableModal'];
  static values = { modal: String };

  connect() {
    console.log('Timetable form modal controller connected');
  }
  openModal(event) {
    console.log('openModal');
    let modalType = event.currentTarget.dataset.form;
    let modalTarget = `${modalType}ModalTarget`;
    this[modalTarget].classList.remove('hidden');
    this.modalValue = modalTarget;
    document.querySelector('body').classList.add('overflow-hidden');
  }

  submit() {
    console.log('submit');
    // this.modalTarget.classList.add("hidden")
  }

  closeModal() {
    this[this.modalValue].classList.add('hidden');
    document.querySelector('body').classList.remove('overflow-hidden');
  }

  disconnect() {
    console.log('Disconnected dog');
    document.querySelector('body').classList.remove('overflow-hidden');
  }
}
